<html>
<title>Verisk | Relay Navigator™</title>
    <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0" />
    <!-- <link rel="stylesheet" href="https://kendo.cdn.telerik.com/themes/5.5.0/default/default-main.css" /> -->
    <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet" />

    <body>
        <router-outlet (attach)="onPageRestored($event)"></router-outlet>

    </body>
</html>